import script from "./PhoneBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneBar.vue?vue&type=script&setup=true&lang=js"

import "./PhoneBar.vue?vue&type=style&index=0&id=3918b740&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3918b740"]])

export default __exports__